import React from "react";
import { Link } from "react-router-dom";

function HeroSection() {
  return (
    <div
      className="relative h-screen w-full bg-cover bg-center bg-fixed"
      style={{
        backgroundImage: `url("Photos/Brandflow Hero Section.jpg")`,
      }}
    >
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/50"></div>

      {/* Content */}
      <div className="relative z-10 h-full flex items-center justify-center px-6">
        <div
          className="
            backdrop-blur-md bg-primary-color/10 border border-white/20 shadow-xl
            rounded-3xl px-10 py-12 max-w-3xl text-center animate-fadeUp
          "
        >
          <h1 className="text-white font-extrabold text-4xl sm:text-5xl md:text-6xl lg:text-7xl drop-shadow-lg">
            BrandFlow
          </h1>

          <p className="mt-5 text-white/90 text-lg sm:text-xl md:text-2xl font-light leading-relaxed">
            Crafting Brands that Grow Beyond Boundaries
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="#services"
              className="px-6 py-3 rounded-full bg-primary-color text-secondary-color font-semibold text-lg hover:bg-secondary-color hover:text-white transition-all shadow-lg"
            >
              Explore Services
            </a>

            <Link
              to="/contact"
              className="px-6 py-3 rounded-full bg-primary-color text-secondary-color font-semibold text-lg hover:bg-secondary-color hover:text-white transition-all shadow-lg"
              // className="px-6 py-3 rounded-full border border-white/40 text-secondary-color font-semibold text-lg hover:bg-white/20 transition-all backdrop-blur-sm"
            >
              Get in Touch
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeroSection;
